import React from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import MainContentGrid from '../MainContentGrid';
// I have ABSOLUTELY NO IDEA WHY, but parcel on the heroku dyno cannot resolve the folder
// if its name is simply 'puzzles'. It had to be anything else, such as '_puzzles'.
// The implication is that something is clashing with that name, but what?
// It cannot be reproduced locally and the production error gives little to no helpful info.
import Arithmeglyphs from '../_puzzles/Arithmeglyphs';
import Megarubigram from '../_puzzles/Megarubigram';
import Morphology from '../_puzzles/Morphology/Morphology';
import ArchiveMorphology from '../_puzzles/ArchiveMorphology/ArchiveMorphology';
import Pathword from '../_puzzles/Pathword';
import Pathword5x5 from '../_puzzles/Pathword5x5';
import Rubigram from '../_puzzles/Rubigram';
import Triword from '../_puzzles/Triword';
import Truthsorting from '../_puzzles/Truthsorting';
import Ultrarubigram from '../_puzzles/Ultrarubigram';
import TopBar from '../TopBar';
import Footer from '../Footer';
import LoadingWrapper from './LoadingWrapper';
import SubmissionsPage from '../SubmissionsPage';
import AccountPage from '../AccountPage';
import AboutPage from '../AboutPage';
import BlogPostPage from '../BlogPostPage';
import { saveArithmeglyphs } from '../_puzzles/Arithmeglyphs/arithmeglyphsUtils';
import { saveMegarubigram } from '../_puzzles/Megarubigram/megarubigramUtils';
import { saveMorphology } from '../_puzzles/Morphology/morphologyUtils';
import { savePathword } from '../_puzzles/Pathword/pathwordUtils';
import { savePathword5x5 } from '../_puzzles/Pathword5x5/pathword5x5utils';
import { saveRubigram } from '../_puzzles/Rubigram/rubigramUtils';
import { saveTriword } from '../_puzzles/Triword/triwordUtils';
import { saveTruthsorting } from '../_puzzles/Truthsorting/truthsortingUtils';
import { saveUltrarubigram } from '../_puzzles/Ultrarubigram/ultrarubigramUtils';
import ErrorBoundary from '../ErrorBoundary';
import AdminAnalytics from '../AdminAnalytics/AdminAnalytics';
import MorphologyProcessor from '../MorphologyProcessor/MorphologyProcessor';
import Wordfinder from '../Wordfinder/Wordfinder';
import Pathfinder from '../Pathfinder/Pathfinder';
import Formatter from '../Formatter/Formatter';
import './ContentSwitcher.less';

// Did this because I wanted the topbar to be a subcomponent of the router so that
// clicking links there would be fast and not require full reload.
// If the router only returned the component, then the router itself is BETWEEN the topbar
// and the footer, and then the links in the footer and topbar would need to do a full reload.
const layout = (Component: React.ComponentType, onSave: () => void, keepMobileFooter?: boolean) => (
  <>
    <TopBar onSave={onSave}/>
    <LoadingWrapper>
      <ErrorBoundary>
        <Component/>
      </ErrorBoundary>
    </LoadingWrapper>
    <Footer keepMobileFooter={keepMobileFooter} />
  </>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: layout(MainContentGrid, () => {}, true),
  },
  {
    path: '/arithmeglyphs',
    element: layout(Arithmeglyphs, saveArithmeglyphs),
  },
  {
    path: '/megarubigram',
    element: layout(Megarubigram, saveMegarubigram),
  },
  {
    path: '/morphology',
    element: layout(Morphology, saveMorphology),
  },
  {
    // Permalink to a past Morphology puzzle, e.g. /morphology/2025/10/3.
    // ArchiveMorphology handles its own saving internally, so no onSave is needed.
    path: '/morphology/:year/:month/:day',
    element: layout(ArchiveMorphology, () => {}),
  },
  {
    path: '/pathword',
    element: layout(Pathword, savePathword),
  },
  {
    path: '/pathword5x5',
    element: layout(Pathword5x5, savePathword5x5),
  },
  {
    path: '/rubigram',
    element: layout(Rubigram, saveRubigram),
  },
  {
    path: '/triword',
    element: layout(Triword, saveTriword),
  },
  {
    path: '/truthsorting',
    element: layout(Truthsorting, saveTruthsorting),
  },
  {
    path: '/ultrarubigram',
    element: layout(Ultrarubigram, saveUltrarubigram),
  },
  {
    path: '/submissions',
    element: layout(SubmissionsPage, () => {}),
  },
  {
    path: '/account',
    element: layout(AccountPage, () => {}),
  },
  {
    path: '/about',
    element: layout(AboutPage, () => {}),
  },
  {
    path: '/on-ending-morphology',
    element: layout(BlogPostPage, () => {}),
  },
  {
    path: '/wordfinder',
    element: layout(Wordfinder, () => {}),
  },
  {
    path: '/pathfinder',
    element: layout(Pathfinder, () => {}),
  },
  {
    path: '/formatter',
    element: layout(Formatter, () => {}),
  },
  {
    path: '/admin/analytics',
    element: layout(AdminAnalytics, () => {}),
  },
  {
    path: '/admin/morphology-processor',
    element: layout(MorphologyProcessor, () => {}),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

const ContentSwitcher = () => {
  return (
    <RouterProvider router={router}/>
  );
};

export default ContentSwitcher;